import { render } from "./CButtonDanger.vue?vue&type=template&id=0773a88d&scoped=true"
const script = {}

import "./CButtonDanger.vue?vue&type=style&index=0&id=0773a88d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0773a88d"]])

export default __exports__